import * as yup from 'yup';
import { fundraiserNew as TEXT } from 'locales/en';
import { escapedCountryField } from 'utils/transform';

export const AMOUNT_OPTIONS = [20, 30, 50, 100];
export const FIELD_NAMES = {
  name: 'name',
  goal: 'goal',
  image: 'image',
  description: 'description',
  long_description: 'long_description', //HTML is allowed here
  video_embed: 'video_embed',
  country: escapedCountryField,
  city: 'city',
  amount_options_0: 'amount_options_0',
  amount_options_1: 'amount_options_1',
  amount_options_2: 'amount_options_2',
  amount_options_3: 'amount_options_3',
};

export const defaultValues = {
  [FIELD_NAMES.name]: '',
  [FIELD_NAMES.goal]: '',
  [FIELD_NAMES.image]: null,
  [FIELD_NAMES.description]: '',
  [FIELD_NAMES.long_description]: '',
  [FIELD_NAMES.country]: {},
  [FIELD_NAMES.city]: '',
  [FIELD_NAMES.video_embed]: null,
  [FIELD_NAMES.amount_options_0]: AMOUNT_OPTIONS[0],
  [FIELD_NAMES.amount_options_1]: AMOUNT_OPTIONS[1],
  [FIELD_NAMES.amount_options_2]: AMOUNT_OPTIONS[2],
  [FIELD_NAMES.amount_options_3]: AMOUNT_OPTIONS[3],
};
const IMAGE_SIZE = 1048576; //1MB
const IMAGE_TYPES = ['image/jpeg', 'image/png'];

const schema = yup.object().shape({
  [FIELD_NAMES.name]: yup.string().required(TEXT.errors[FIELD_NAMES.name]),
  [FIELD_NAMES.goal]: yup.string().required(TEXT.errors[FIELD_NAMES.goal]),
  [FIELD_NAMES.image]: yup
    .mixed()
    .nullable()
    .required(TEXT.errors.image.required)
    .test('size', TEXT.errors.image.max, (value) => {
      if (!value?.lastModified) {
        return true;
      } else {
        return value && value.size <= IMAGE_SIZE;
      }
    })
    .test('type', TEXT.errors.image.type, (value) => {
      if (!value?.lastModified) {
        return true;
      } else {
        return value && IMAGE_TYPES.indexOf(value.type) > -1;
      }
    }),
  [FIELD_NAMES.description]: yup
    .string()
    .required(TEXT.errors[FIELD_NAMES.description]),
  [FIELD_NAMES.country]: yup.object().shape({
    name: yup.string().nullable().required(TEXT.errors.country),
    dial_code: yup.string(),
    code: yup.string(),
  }),
  [FIELD_NAMES.city]: yup.string().required(TEXT.errors.city),
  [FIELD_NAMES.long_description]: yup.string(),
  [FIELD_NAMES.amount_options_0]: yup
    .number()
    .nullable()
    .min(3, TEXT.errors.amount.min)
    .required(TEXT.errors.amount.required)
    .transform((value, originalValue) => (originalValue === '' ? null : value)),
  [FIELD_NAMES.amount_options_1]: yup
    .number()
    .nullable()
    .min(3, TEXT.errors.amount.min)
    .required(TEXT.errors.amount.required)
    .transform((value, originalValue) => (originalValue === '' ? null : value)),
  [FIELD_NAMES.amount_options_2]: yup
    .number()
    .nullable()
    .min(3, TEXT.errors.amount.min)
    .required(TEXT.errors.amount.required)
    .transform((value, originalValue) => (originalValue === '' ? null : value)),
  [FIELD_NAMES.amount_options_3]: yup
    .number()
    .nullable()
    .min(3, TEXT.errors.amount.min)
    .required(TEXT.errors.amount.required)
    .transform((value, originalValue) => (originalValue === '' ? null : value)),
});

export default schema;
